import { OtherPayment, Refloor, Payoff } from "../../common/PayoffRefloorPills"

export default function TxnType({ txn }) {
  const txnFor = txn.attributes['txn-for']

  if (txnFor == "Refloor" || txnFor == 2) {
    return <Refloor />
  } else if (txnFor == "Payoff" || txnFor == 11 || txn.attributes['unit-payoff']) {
    return <Payoff />
  } else if (txnFor == "Unit Payment" || txnFor == 10) {
    return <OtherPayment type={'Partial Payment'} />
  } else {
    return <OtherPayment type={'Other'} />
  }
}